exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Switcher__container{font:var(--main-font);white-space:nowrap}.Switcher__label{font-weight:700;font-size:11px;margin-bottom:7px}.Switcher__item+.Switcher__item{margin-left:5px}", ""]);

// Exports
exports.locals = {
	"container": "Switcher__container",
	"label": "Switcher__label",
	"item": "Switcher__item"
};